"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = __importDefault(require("../../client"));
const path = '/event';
function updateEvent(auth, event, body) {
    const eventId = event.split(':')[1];
    return client_1.default.patch(`${path}/${eventId}`, body, {
        headers: {
            Authorization: auth,
        },
    });
}
exports.default = updateEvent;
